// Force page reload on browser back button navigation to prevent stale data
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
    console.log('BOLD LOAD');

    // Define elements
    const errorModal = document.querySelector('#error-modal');
    const errorMax = errorModal ? errorModal.querySelector('#custom-max') : null;
    const swatches = document.querySelector('.bold_option_swatch');
    const customCart = document.querySelector('#custom-cart');
    let swatchMem = [];
    const manualEvent = new Event('change');
    const popupWrapper = document.querySelector('#selection-modal .choice-wrapper');
    const lollieSearch = document.querySelector('#lollie-search');
    const lollieNames = swatches ? swatches.querySelectorAll('.bold_option_value .bold_option_value_title') : [];
    const lollieSearchMessage = document.querySelector('#lollie-search-message');

    // Safety check - if options don't exist on the page, stop execution
    if (!swatches) return; 

    // Function to apply data attributes for filtering (Based on Title | Category format)
    function applyDataFilterAttribute() {
      const filterSet = new Set();
      const titles = swatches.querySelectorAll('.bold_option_value_title');
      titles.forEach((title) => {
        if (title.textContent.includes('|')) {
          const filterValue = title.textContent.split('|')[1].trim();
          filterSet.add(filterValue);
          title.textContent = title.textContent.split('|')[0];
          title.closest('.bold_option_value').setAttribute('data-filter', filterValue);
        }
      })
      let filters = [...filterSet];
      createFilterElement(filters);
    }

    // Identifies out-of-stock items indicated by an asterisk (*)
    function createOutOfStock() {
      lollieNames.forEach((lolly) => {
        if (lolly.textContent.includes('*')) {
          lolly.closest('.bold_option_value').classList.add('out-of-stock');
        }
      })
    }

    // Creates radio buttons for filtering categories
    function createFilterElement(filters) {
      const filterParent = document.querySelector('.lollie-filters');
      if (!filterParent) return;
      filters.forEach((filter) => {
        const filterLabel = document.createElement('label');
        filterLabel.textContent = filter;
        const filterRadio = document.createElement('input');
        filterRadio.value = filter;
        filterRadio.name = 'filter';
        filterRadio.type = 'radio';
        filterRadio.classList.add('custom-filter');
        filterLabel.appendChild(filterRadio);
        filterParent.appendChild(filterLabel);
      })
      const filterLabel = document.createElement('label');
      filterLabel.textContent = 'All';
      const filterRadio = document.createElement('input');
      filterRadio.value = 'All';
      filterRadio.name = 'filter';
      filterRadio.type = 'radio';
      filterRadio.setAttribute('checked', 'checked');
      filterRadio.classList.add('custom-filter');
      filterLabel.appendChild(filterRadio);
      filterParent.appendChild(filterLabel);
    }

    // Applies the selected filter to display or hide specific swatches
    function applyFilter(filter) {
      let swatchElements = swatches.querySelectorAll('.bold_option_value');
      if (filter === 'All') {
        swatchElements.forEach((element) => { element.style.display = '' })
      } else {
        swatchElements.forEach((element) => {
          if (element.getAttribute('data-filter') === filter) {
            element.style.display = '';
          } else {
            element.style.display = 'none'
          }
        })
      }
    }

    // Injects the search bar into the DOM
    function applySearchBar() {
      if (!lollieSearch) return;
      swatches.querySelector('.bold_option_element').insertBefore(lollieSearch.parentElement, swatches.querySelector('.bold_option_value'));
      lollieSearch.addEventListener('input', (e) => {
        setTimeout(() => {
          performSearch(e)
        }, 800)
      });
    }

    // Executes search logic on lollie names
    function performSearch(event) {
      let search = event.target.value.toUpperCase();
      let foundLollies = 0;
      for (let i = 0; i < lollieNames.length; i++) {
        if (lollieNames[i].textContent.toUpperCase().indexOf(search) > -1) {
          lollieNames[i].closest('.bold_option_value').style.display = '';
          foundLollies++;
        } else {
          lollieNames[i].closest('.bold_option_value').style.display = 'none';
        }
      }
      if (lollieSearchMessage) {
        if (foundLollies && search) {
          lollieSearchMessage.textContent = `Found ${foundLollies} Lollies that match your search!`
        } else if (!foundLollies && search) {
          lollieSearchMessage.textContent = "No Lollies found :( ."
        } else {
          lollieSearchMessage.textContent = "";
        }
      }
    }

    // Restructures swatch titles for better UX styling
    function extractName() {
      let swatchElements = swatches.querySelectorAll('.bold_option_value');
      swatchElements.forEach((element) => {
        element.querySelector('label').append(element.querySelector('.bold_option_value_title'));
        const swatchTitle = element.querySelector('.bold_option_swatch_title');
        if (swatchTitle) swatchTitle.remove();
      })
    }

    // Fetches maximum allowed lollies (either from global window object or by parsing the selected radio option)
    function getChoiceMax() {
      if (typeof window.max_lolly_choices !== 'undefined' && window.max_lolly_choices) {
        return window.max_lolly_choices;
      } else {
        const radioSelection = document.querySelector('.bold_option_radio input:checked');
        if (radioSelection) {
          return parseInt(radioSelection.value.split('(')[1].replace(/[^0-9]/g, ''));
        }
      }
      return 0;
    }

    // Calculates current amount of chosen lollies
    function getChoiceCurrent() {
      let total = 0;
      let checkcedCheckboxes = document.querySelectorAll('.bold_option_swatch input[type="checkbox"]:checked');
      checkcedCheckboxes.forEach((checked) => {
        const qtyInput = checked.closest('label').nextElementSibling.querySelector('input');
        if (qtyInput) {
          total += parseInt(qtyInput.value) || 0;
        }
      })
      return total;
    }

    // Injects custom +/- buttons for quantity management
    function createQuantityButtons(checkbox) {
      let quantityParent = checkbox.closest('label').nextElementSibling;
      let inputElement = quantityParent.querySelector('input');
      if (inputElement) {
        if (quantityParent.querySelector('.quantity-increment')) return; // Prevent duplicate buttons
        let incrementButton = document.createElement('span');
        let decrementButton = document.createElement('span');
        incrementButton.textContent = '+';
        decrementButton.textContent = '-';
        incrementButton.classList.add('quantity-button', 'quantity-increment');
        decrementButton.classList.add('quantity-button', 'quantity-decrement');
        quantityParent.prepend(decrementButton);
        quantityParent.append(incrementButton);
        
        incrementButton.addEventListener('click', () => {
          inputElement.value = parseInt(inputElement.value) + 1;
          inputElement.dispatchEvent(manualEvent);
        })
        decrementButton.addEventListener('click', () => {
          if (inputElement.value != 0) {
            inputElement.value -= 1;
            inputElement.dispatchEvent(manualEvent);
          }
        })
        inputElement.setAttribute('disabled', 'disabled');
      } else {
        quantityParent.replaceChildren();
      }
    }

    // Handles logic when a lollie checkbox is interacted with
    function handleCheckboxEvent(checkbox, max, current) {
      if (current > max) {
        setTimeout(() => { checkbox.click() }, 0);
      }
      createQuantityButtons(checkbox);
    }

    // Prevents exceeding the maximum choice limit manually
    function handleNumberEvent(input, max, current) {
      if (current > max) {
        input.value = input.value - (current - max);
        input.dispatchEvent(manualEvent);
      }
    }

    // Manages user UI feedback regarding choice limitations and displays ATC button when limit is reached
    function userFeedback(max, current, displayError) {
      if (displayError && errorModal && errorMax) {
        errorMax.textContent = max;
        errorModal.style.display = "flex";
        setTimeout(() => { errorModal.style.opacity = "1" }, 300);
        setTimeout(() => { errorModal.style.opacity = "0" }, 3600);
        setTimeout(() => { errorModal.style.display = "none" }, 4000);
      }
      
      const optionStatus = document.querySelector('#option-status');
      if (optionStatus) {
        if (current && !displayError) {
          document.querySelectorAll('.status-min').forEach((span) => { span.textContent = current });
          document.querySelectorAll('.status-max').forEach((span) => { span.textContent = max });
          optionStatus.style.transform = "translateY(0)";
        } else if (current == 0) {
          optionStatus.style.transform = "translateY(100%)";
          document.querySelectorAll('.status-min').forEach((span) => { span.textContent = current });
          document.querySelectorAll('.status-max').forEach((span) => { span.textContent = max });
        }
      }

      // Show custom ATC buttons only when the max amount is reached
      if (max === current) {
        document.querySelectorAll('.custom-cart').forEach((cart) => { cart.style.display = "inline-block" });
      } else if (max != current) {
        document.querySelectorAll('.custom-cart').forEach((cart) => { cart.style.display = "none" });
      }
    }

    // Logic for displaying the floating edit/selection modal
    function handlePopUp() {
      const animation = [{ top: "2px" }, { top: "10px" }];
      const animationParams = { duration: 100, iterations: 1 }
      const popupBtn = document.querySelector('.floating-option.floating-button');
      const popup = document.querySelector('#selection-modal');
      if (!popupBtn || !popup) return;

      const config = { characterData: false, attributes: false, childList: true, subtree: false };
      function mutate(mutations) {
        mutations.forEach((mutation) => {
          popupBtn.parentElement.animate(animation, animationParams);
        })
      }
      const observer = new MutationObserver(mutate);
      observer.observe(popupBtn, config);
      
      popupBtn.addEventListener('click', () => {
        populatePopup();
        popup.style.display = "flex";
        setTimeout(() => { popup.style.opacity = "1" }, 300);
      })
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.style.display = "none";
          if (popupWrapper) popupWrapper.replaceChildren();
        }
      })
    }

    // Populates the popup modal with currently selected swatches and ties functionality back to the main swatches
    function populatePopup() {
      if (!popupWrapper) return;
      let inputs = swatches.querySelectorAll('input[type="checkbox"]:checked');
      inputs.forEach((input) => {
        let inputParent = input.closest('.bold_option_value');
        popupWrapper.appendChild(inputParent.cloneNode(true));
      })
      popupWrapper.querySelectorAll('.quantity-button').forEach((button) => {
        button.addEventListener('click', (e) => {
          let clickedElementValue = e.target.parentElement.parentElement.querySelector('input[type="checkbox"]').value;
          if (e.target.textContent === "+") {
            swatches.querySelector(`.bold_option_value:has(input[value="${clickedElementValue}"]) .quantity-increment`).click();
          } else if (e.target.textContent === "-") {
            swatches.querySelector(`.bold_option_value:has(input[value="${clickedElementValue}"]) .quantity-decrement`).click();
          }
          setTimeout(() => {
            popupWrapper.replaceChildren();
            populatePopup();
          }, 600)
        })
      })
      popupWrapper.addEventListener('change', (e) => {
        e.stopImmediatePropagation();
        if (e.target.type === "checkbox") {
          document.querySelector(`.bold_options_loaded input[value="${e.target.value}"]`).click();
          e.stopPropagation();
          e.target.closest('.bold_option_value').remove();
        } else if (e.target.type === "number") {
          let boldInput = document.querySelector(`.bold_options_loaded input.${e.target.classList[0]}`);
          if (boldInput) {
            boldInput.value = e.target.value;
            boldInput.dispatchEvent(manualEvent);
          }
        }
      })
    }

    // Main event delegator handling clicks on swatches and inputs
    function handleChangeEvent(event) {
      if (event.target.classList.contains('custom-filter')) {
        applyFilter(event.target.value);
      } else {
        setTimeout(() => {
          let maxChoices = getChoiceMax();
          let currentChoices = getChoiceCurrent();
          let eventType = event.target.type;
          switch (eventType) {
            case "radio":
              handleRadioEvent(event.target, maxChoices, currentChoices);
              break;
            case "checkbox":
              handleCheckboxEvent(event.target, maxChoices, currentChoices);
              break;
            case "number":
              handleNumberEvent(event.target, maxChoices, currentChoices);
              break;
          }
          userFeedback(maxChoices, currentChoices, currentChoices > maxChoices);
        }, 50)
        setTimeout(() => {
          userFeedback(getChoiceMax(), getChoiceCurrent(), getChoiceCurrent() > getChoiceMax());
        }, 1000)
      }
    }

    // Logic when jar size/type radio button is selected
    function handleRadioEvent(radio, max, current) {
      if (current > max) {
        let selectedSwatches = swatches.querySelectorAll('input:checked');
        selectedSwatches.forEach((swatch) => { swatch.click() });
      }
      try {
        // Switch main image based on radio value
        document.querySelector(`#ProductThumbs img[alt="${radio.value}"]`).click();
      } catch (e) {}
    }

    // Initially highlight selected option
    function addActiveClassOnLoad() {
      document.querySelector('.bold_option_radio input:checked')?.closest('label')?.querySelector('.bold_option_value_title').classList.add('active');
    }

    // Event listeners
    const optionSet = document.querySelector('.bold_option_set');
    if (optionSet) {
      optionSet.addEventListener('change', handleChangeEvent, true);
    }
    
    // Execute initialization functions
    extractName();
    handlePopUp();
    applySearchBar();
    createOutOfStock();
    userFeedback(getChoiceMax(), getChoiceCurrent(), false);
    
    // Triggers fake clicks to force re-evaluation of choices on load
    if (document.querySelector('.bold_option_radio')){
      setTimeout(() => {
        document.querySelector('.bold_option_radio .bold_option_value:nth-child(2) label .bold_option_value_element input').click()
        document.querySelector('.bold_option_radio .bold_option_value:nth-child(1) label .bold_option_value_element input').click()
        document.querySelector('.bold_option_radio .bold_option_value:nth-child(2) label .bold_option_value_element input').click()
        document.querySelector('.bold_option_radio .bold_option_value:nth-child(1) label .bold_option_value_element input').click()
        addActiveClassOnLoad();
      }, 2500)
    }
    
    // Prevent default form submission on enter key
    document.addEventListener('keypress', (e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      }
    })

    // --- FIX FOR SHAPES THEME ---
    // Target the cloned ATC button generated by the Bold app
    const mainAtcButton = document.querySelector('.add-to-cart-btn.bold_clone');
    if (mainAtcButton && mainAtcButton.disabled) { 
      document.querySelectorAll('button.custom-cart').forEach((button) => {
        button.textContent = 'Sold out';
        button.setAttribute('disabled', 'disabled');
      })
    }
  })
})